export const styles = theme => ({
  root: {
    width: '100%',
    height: '100%',
    marginTop: theme.spacing(2),
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: theme.spacing(3),
    boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12)',
    backgroundColor: '#fff'
  },

  notification: {
    color: 'red',
    fontSize: '1rem',
    textAlign: 'left',
    width: '100%',
    marginBottom: '1rem',
  },
  appTabs: {
    boxShadow: 'none',
  },
  tabsRoot: {
    borderBottom: '1px solid #e8e8e8',
  },
  tabsIndicator: {
    backgroundColor: '#1890ff',
  },
  tabRoot: {
    textTransform: 'initial',
    minWidth: 72,

    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(2),
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
      color: '#40a9ff',
      opacity: 1,
    },
    '&$tabSelected': {
      color: '#1890ff',
      fontWeight: theme.typography.fontWeightMedium,
    },
    '&:focus': {
      color: '#40a9ff',
    },
  },
  boxImage: {
    marginTop: 0,
    margin: -theme.spacing(3)
  }
});

export const informationStyle = theme => ({
  root: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(3),
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    width: '100%',

  },
  label: {
    fontSize: '.85rem',
     fontWeight: 410
  },
  menu: {
    width: '15%',
  },
  button: {
    // fontSize: '12px',
    // width: '26px',
    // height: '14px',
    float: 'right',
  },
  imageService: {
    width: '100%',
    height: 'auto',
    display: 'block',
    cursor: 'pointer',
  },
  containerImage: {
    marginTop: '20px',
    width: '560px',
    height: '315px',
    overflow: 'hidden',
    border: '2px solid #F2F2F2',
  },
  workingDays: {
    marginTop: '20px',
  },
  formControl: {
    margin: theme.spacing(1),
    width: '100%'
  },
  icon: {
    fontSize: 80,
  },
  input: {

    fontSize: 18
  },

  note: {
    display: 'block'
  },
  description: {
    marginTop: '12px'
  },
  btnGGMap: {
    margin: '8px 0px 0px 0px',
  },
  helperText: {
    color: '#1E1E83',
    cursor: 'pointer',
    fontSize: 14,
  },
  iOSSwitchBase: {
    '&$iOSChecked': {
      color: theme.palette.common.white,
      '& + $iOSBar': {
        backgroundColor: '#52d869',
      },
    },
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp,
    }),
  },
  iOSChecked: {
    transform: 'translateX(15px)',
    '& + $iOSBar': {
      opacity: 1,
      border: 'none',
    },
  },
  containerLabel: {
    paddingBottom: '0 !important'
  },
  customFormLabel: {
    display: 'block',
    transformOrigin: 'top left',
    transform: 'translate(0, 1.5px) scale(0.75)',
    color: 'rgba(0, 0, 0, 0.85)',
    fontWeight: '500'
  },
  iOSBar: {
    borderRadius: 13,
    width: 42,
    height: 26,
    marginTop: -13,
    marginLeft: -21,
    border: 'solid 1px',
    borderColor: theme.palette.grey[400],
    backgroundColor: theme.palette.grey[400],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  iOSIcon: {
    width: 24,
    height: 24,
  },
  iOSIconChecked: {
    boxShadow: theme.shadows[1],
  },
});